import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock-open-outline",
  "use": "lock-open-outline-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"lock-open-outline\"><path fill-rule=\"evenodd\" d=\"M4.5 15.75h9v-7.5h-9v7.5Zm9-9h-.75v-1.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75h1.425A2.327 2.327 0 0 1 9 2.925a2.327 2.327 0 0 1 2.325 2.325v1.5H4.5c-.825 0-1.5.675-1.5 1.5v7.5c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-7.5c0-.825-.675-1.5-1.5-1.5ZM9 13.5c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol